import { useCallback, useRef } from 'react';

import { useTypedSelector } from '../../../shared/hooks';
import { useGetWidgetsMutation } from '../data-layer/violationsTabApi';
import { getFilterPayload } from '../utils';

const useGetWidget = () => {
  const { activeFilters, tabInAction, searchKey } = useTypedSelector(
    (state) => state.aag.violationsTab.controls
  );

  const abortRef = useRef<((reason: string) => void) | null>(null);

  const [fetchWidgets, { isLoading, isError }] = useGetWidgetsMutation();

  const handleFetchWidgets = useCallback(
    async (endpoint: string) => {
      abortRef.current?.('New Search');

      const activeFiltersMap = Object.fromEntries(
        activeFilters.map((f) => [f.value, f.options.map((o) => o.value)])
      );

      const baseFilters = getFilterPayload(
        activeFiltersMap,
        tabInAction ?? undefined,
        searchKey
      );

      try {
        const controller = fetchWidgets({
          endpoint,
          payload: {
            filters: {
              ...baseFilters,
            },
          },
        });

        abortRef.current = () => controller.abort();

        const response = await controller.unwrap();

        return response;
      } catch {
        throw Error('Failed fetching graph cluster');
      }
    },
    [fetchWidgets, activeFilters, tabInAction, searchKey]
  );

  return {
    handleFetchWidgets,
    isLoading,
    isError,
  };
};

// eslint-disable-next-line import/prefer-default-export
export { useGetWidget };
